// Red de seguridad contra el traductor automático del navegador (Chrome
// "Traducir página", algunas extensiones): al traducir, el navegador reemplaza
// los textos por otros nodos y, cuando React quiere actualizar un texto que
// ya no está donde lo dejó, la pantalla entera se rompe ("Algo salió mal").
// Con esto, en vez de romperse, React ignora ese nodo y sigue.
// Referencia: github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
